import { Search } from "@mui/icons-material"
import { InputAdornment, Pagination, TextField } from "@mui/material"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import Loader from "../../../components/Loader/Loader"
import { useAllBlogsQuery } from "../../../helpers/blogApi"
import { motion } from 'framer-motion';
import { useState } from "react"
import { debounce } from 'lodash'


const Blogs = () => {

  const navigate = useNavigate()
  const [page, setpage] = useState(1)
  const [title, settitle] = useState('')
  const [value, setvalue] = useState('')

  const { data, isFetching } = useAllBlogsQuery({ page, title })

  const debouncedSearch = debounce((value) => {
    settitle(value)
  }, 1000)

  const handleChange = (e) => {
    setpage(1)
    debouncedSearch(e.target.value)
    setvalue(e.target.value)
  }

  return (
    <div className="dark:bg-gray-900 transition-all duration-700">


      <Helmet >
        <title> CodeZone | Blog</title>
      </Helmet>

      <div className=' pt-[52px] md:pt-[60px]'>
        <div className=' main-class max-w-screen-xl w-[90%] mx-auto md:w-full  min-h-[77vh] '>
          <h1 className='text-xl md:text-2xl text-center font-bold dark:text-white'>Directory of <span className='text-red-500'>Trending Blogs</span></h1>

          <div className="mt-5 md:mt-7 mb-4">
            <TextField
              placeholder='Search'
              id='phone'
              required
              fullWidth
              onChange={(e) => handleChange(e)}
              value={value}
              InputProps={{
                disableUnderline: true,
                style: {
                  fontSize: 15,
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ fontSize: '25px' }} />
                  </InputAdornment>
                )
              }}
              sx={{
                '& .MuiInputBase-root': {
                  padding: '7px 10px',
                  borderRadius: '10px',
                  transition: 'all 0.4s ease-in-out',
                  backgroundColor: '#f2f7fb',
                  width: { sm: '365px' }
                },
                '& .Mui-focused': {
                  backgroundColor: 'black !important',
                  color: 'white',
                  '& .MuiSvgIcon-root': {
                    color: 'white'
                  },
                  '& ::placeholder': {
                    color: 'white',
                    opacity: '0.7'
                  }
                },

              }}
              variant="standard"
            />
          </div>

          {isFetching ? (
            <Loader height={'40vh'} text='Loading blogs...' />
          ) : (
            <motion.div
              whileInView={{ y: [150, 0], opacity: [0, 1] }}
              transition={{ duration: 1.0, delay: 0.2 }}
              viewport={{ once: true }}
              initial='hidden'
              style={{ opacity: 0 }}
            >
              <div className='grid grid-cols-1 gap-5 mb-5 md:mb-10  md:grid-cols-2 lg:grid-cols-3'>

                {data.blogs.length > 0 && data.blogs.map((item, i) => (
                  <div key={i} onClick={() => navigate(`/blog/${item.slug}`)} className='rounded-xl cursor-pointer hover:scale-105 duration-700 bg-white shadow-lg hover:shadow-xl'>
                    <img src={item.image} alt="img" className="w-full h-[200px] md:h-[250px] rounded-t-xl" />
                    <div className="p-3">
                      <h1 className="font-bold text-[15px] md:text-[17px]">
                        {item.title}
                      </h1>
                      <div className="py-1">
                        <p className="text-[13px] md:text-[15px]  line-clamp-4">
                          {item.shortDesc}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          )}
          <div className='flex justify-center my-3'>
            {data && data.resultPerPage < data.filteredBlogsCount && (

              <Pagination color='primary' size='medium'
                count={Math.ceil(data.totalBlogCount / data.resultPerPage)}
                page={page}
                shape='rounded'
                onChange={(event, value) => setpage(value)}
                showLastButton showFirstButton hideNextButton hidePrevButton
                onClick={() => window.scrollTo(0, 0)}

              />
            )}
          </div>

          {!isFetching && data.blogs.length === 0 && (
            <div>
              <p className="text-center text-xs underline underline-offset-8 text-gray-400 my-7">
                No blog found
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Blogs